import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Fade from 'react-reveal/Fade';
import ReactHtmlParser from 'react-html-parser';

const styles = theme => ({

})
class Inventory extends React.Component{
    constructor(props){
        super(props);
        this.state = {
         items:[
            { 
                img: "https://duwun-data.sgp1.cdn.digitaloceanspaces.com/react-assets/image/displayIcon.png", 
                title: 'Display', 
                description: "Everybody can do display but Duwun can optimize it to increase the CTR by 10x the industry average with innovative formats such as<span class='hightlight'> video, html, gifs.</span>", 
                delay: 200
            },
            { 
                img: "https://duwun-data.sgp1.cdn.digitaloceanspaces.com/react-assets/image/tvIcon.png", 
                title: 'Product placement', 
                description: "The best way to demonstrate your product in action is by integrating your brand in a show. We have<span class='hightlight'> various TV shows</span> that can highlight your product in action.", 
                delay: 500
            },
            { 
                img: "https://duwun-data.sgp1.cdn.digitaloceanspaces.com/react-assets/image/contentIcon.png", 
                title: 'Native Content Creation', 
                description: "Some people requires quality content to be convinced. Duwun is an expert in native content. We tell your story in the way our audience engage with it especially with video.", 
                delay: 300
            },
            { 
                img: "https://duwun-data.sgp1.cdn.digitaloceanspaces.com/react-assets/image/globeIcon.png", 
                title: "Video Pre-roll", 
                description: "Every now and then you just want everyone to see your brand everywhere. We have <span class='hightlight'>50 million</span> video views a month with <span class='hightlight'>20 million</span> social unique users watching our videos.", 
                delay: 400
            },
           
            ]
        };
      }  
    render(){
        const { classes } = this.props;
        return(
            <Grid container  
            direction="row"
            justify="center"
            alignItems="center"
            className="inventory advertise-layout"
            >
            <Grid item md={12} xs={12} >
            <h2 style={{ padding: '30px 0px 10px', color: '#ed7123', fontSize: 30 }}>Our Inventory</h2>
            </Grid>
            {
                this.state.items.map((item, i) => {
                    return(
                        <React.Fragment key={i}>
                            <Grid item md={6} xs={12} className="inventory-item">
                                <Fade delay={item.delay} duration={1500}>
                                    <img src={item.img} />
                                    <h3>{item.title}</h3>
                                    <p>{ReactHtmlParser(`${item.description}`)}</p>
                                </Fade>
                            </Grid>
                        </React.Fragment>
                    )
            })
            }
          
        </Grid>
        )
    }
}
export default withStyles(styles)(Inventory);